import {createApi} from '@reduxjs/toolkit/query/react';

import {ERequestType, TRequestTableResponseWithPagination} from 'shared/types/requests';
import {IRpcDeleteResponse} from 'shared/types/rpc';
import {axiosBaseQuery} from 'store/api/base-query';

import {AIS_SUMMARY_TRANSACTION_PROTOCOL_API_PREFIX} from '../model/constants';
import {
    ISummaryTransactionProtocolDto,
    ISummaryTransactionProtocolFilters,
    ISummaryTransactionProtocolTableRowsParams,
} from '../model/types';

export const AisSummaryTransactionProtocolInterfaceApi = createApi({
    reducerPath: 'aisSummaryTransactionProtocolInterfaceApi',
    tagTypes: ['AisSummaryTransactionProtocolInterface'],
    baseQuery: axiosBaseQuery(),
    endpoints: builder => ({
        fetchAisSummaryTransactionProtocolTable: builder.query<
          TRequestTableResponseWithPagination<ISummaryTransactionProtocolDto>,
          ISummaryTransactionProtocolFilters | undefined
        >({
            query: params => ({
                url: AIS_SUMMARY_TRANSACTION_PROTOCOL_API_PREFIX,
                method: ERequestType.GET,
                params,
            }),
        }),
        deleteAisSummaryTransactionProtocolTableRows: builder.mutation<
          IRpcDeleteResponse,
          ISummaryTransactionProtocolTableRowsParams
        >({
            query: ({ids}) => ({
                url: `${AIS_SUMMARY_TRANSACTION_PROTOCOL_API_PREFIX}/rpc/delete-list`,
                method: ERequestType.DELETE,
                data: {ids},
            }),
        }),
        updateAisSummaryTransactionProtocolTableRowsStatus: builder.mutation<
          string,
          ISummaryTransactionProtocolTableRowsParams
        >({
            query: ({ids}) => ({
                url: `${AIS_SUMMARY_TRANSACTION_PROTOCOL_API_PREFIX}/changeStatus`,
                method: ERequestType.POST,
                data: {ids},
            }),
        }),
        putAisSummaryTransactionProtocolTableRowValue: builder.mutation<
          string,
          ISummaryTransactionProtocolDto
        >({
            query: data => ({
                url: `${AIS_SUMMARY_TRANSACTION_PROTOCOL_API_PREFIX}/update`,
                method: ERequestType.PUT,
                data,
            }),
        }),
    }),
});

export const {
    useFetchAisSummaryTransactionProtocolTableQuery,
    useDeleteAisSummaryTransactionProtocolTableRowsMutation,
    useUpdateAisSummaryTransactionProtocolTableRowsStatusMutation,
    usePutAisSummaryTransactionProtocolTableRowValueMutation,
} = AisSummaryTransactionProtocolInterfaceApi;
